import React from 'react';
import Card from 'components/Containers/Card';
import Container from 'components/Containers/Container';
import Game from 'modules/Game/EducationGame';

const EducationGame = (props) => {
  return (
    <Container name='Education Game' parentName='Trò chơi'>
      <Card title='TRÒ CHƠI GIÁO DỤC' subTitle='TRÒ CHƠI'>
        <Game />
      </Card>
    </Container>
  );
};

export default EducationGame;
